export default function permissions(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                permission: action.permission,
            }
        default:
            return state;
    }
}
